
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.304","height":"21.069"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 315","transform":"translate(1 1)","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2"}},[_c('circle',{attrs:{"data-name":"Ellipse 31","cx":"8.152","cy":"8.152","transform":"translate(0 2.766)","r":"8.152"}}),_c('path',{attrs:{"data-name":"Line 34","d":"M8.152 0v8.138"}})])])
          )
        }
      }
    